import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenModel } from 'app/models/token.model';
import { environment } from 'environments/environment';
import { ConfigService } from './config.service';
import { UserMFASettingModel, VerifyOTPModel } from 'app/models/login.model';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APPLICATION_ID } from 'app/models/constants';


@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  constructor(private api: HttpClient, private config: ConfigService) { }

  public GetSecuritySettings(): Observable<UserMFASettingModel> {
      return this.api.get<UserMFASettingModel>(this.config.getApiRoute('api/v3/client-portal/user-settings/security')).pipe(
          map(data => {
              return data;
          }),
          catchError((err: HttpErrorResponse) => {
              return throwError(err.error.message);
          }));
  }

  public GetOTPDetails( otp_id:string): Observable<TokenModel> {
    return this.api.get<TokenModel>(this.config.getApiRoute(`api/v3/session/otp/${otp_id}`)).pipe(
        map(data => {
            return data;
        }),
        catchError((err: HttpErrorResponse) => {
            return throwError(err.error.message);
        }));
}

public ResendOTP(argument: VerifyOTPModel): Observable<TokenModel> {
  const otp_id= argument.otp_id;
  return this.api.post<TokenModel>(this.config.getApiRoute(`api/v3/session/otp/${otp_id}/resend`), argument).pipe(
      map(data => {
          return data;
      }),
      catchError((err: HttpErrorResponse) => {
          return throwError(err.error.message);
      }));

}

public VerifyOTP(argument: VerifyOTPModel): Observable<TokenModel> {
  const otp_id= argument.otp_id;
  return this.api.post<TokenModel>(this.config.getApiRoute(`api/v3/session/otp/${otp_id}/verify`), argument).pipe(
      map(data => {
          return data;
      }),
      catchError((err: HttpErrorResponse) => {
          return throwError(err.error.message);
      }));

}

  public SaveSecuritySettings(model: UserMFASettingModel): Observable<UserMFASettingModel> {

      return this.api.put<UserMFASettingModel>(this.config.getApiRoute('api/v3/client-portal/user-settings/security'), model).pipe(
        map(data => {
          return data;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error.message);
        }));
  }
  public SaveSecurityPhone(model: UserMFASettingModel): Observable<UserMFASettingModel> {
      return this.api.put<UserMFASettingModel>(this.config.getApiRoute('api/v3/client-portal/user-settings/security/phone'), model).pipe(
        map(data => {
          return data;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error.message);
        }));
  }
  public SetDeviceToken(device_token: string){
      const device_token_key = `${APPLICATION_ID}_device_token`;
      localStorage.setItem(device_token_key, device_token);

  }

    public RemoveDeviceToken(){
      const device_token_key = `${environment.client_id}_device_token`;
      localStorage.removeItem(device_token_key);

  }

  public GetDeviceToken(): string{
    const device_token_key = `${APPLICATION_ID}_device_token`;
   return localStorage.getItem(device_token_key);

}




}
